import { BasicEvent } from "./BasicEvent";
export class VerksamhetshandelseUpdatedEventMessage extends BasicEvent {
    arbetsorderId: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "VerksamhetshandelseUpdatedEventMessage";
}
